// extracted by mini-css-extract-plugin
export default {"carousel":"Carousel_carousel__Zz221","slide":"Carousel_slide__VB6yH","heading":"Carousel_heading__X9sxD","subheading":"Carousel_subheading__5CMQt"};